// components/Layout/Topbar.js
import { useState, useRef, useEffect } from 'react';
import { FaBars, FaBell, FaUserCircle, FaUser, FaCog, FaSignOutAlt, FaCheckCircle } from 'react-icons/fa';
import './Layout.css';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useToast } from '../Toast';
import { baseurl } from '../../pages/Baseurl';




function Topbar({ toggleSidebar }) {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const notifRef = useRef(null);
  const profileRef = useRef(null);
const [user, setUser] = useState(null);

  const navigate = useNavigate();
  const toast = useToast();


   useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);



  const handleLogout = async () => {
    const confirmLogout = window.confirm('Are you sure you want to logout?');
    if (!confirmLogout) return;

    try {
      const accessToken = localStorage.getItem('accessToken');

      await axios.post(
        `${baseurl}/auth/logout`,
        {},
        {
          withCredentials: true,
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
    } catch (err) {
      console.log('Logout error:', err.response?.data || err.message);
    } finally {
      localStorage.clear();
      toast('Logged out successfully', 'success');
      navigate('/');
    }
  };




  useEffect(() => {
    function handleClickOutside(e) {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const notifications = [
    { id: 1, text: 'New order received', time: '5m ago' },
    { id: 2, text: 'Server backup completed', time: '1h ago' },
    { id: 3, text: 'New comment on your post', time: '3h ago' },
  ];

  return (
    <header className="topbar">
      <button className="menu-toggle-btn" onClick={toggleSidebar}>
        <FaBars />
      </button>

      <div className="topbar-title">Dashboard</div>

      <div className="topbar-right">
        {/* NOTIFICATIONS */}
        <div className="dropdown-wrapper" ref={notifRef}>
          {/* <button
            className="icon-btn"
            onClick={() => {
              setShowNotifications((p) => !p);
              setShowProfile(false);
            }}
          >
            <FaBell />
            {notifications.length > 0 && (
              <span className="badge-dot">{notifications.length}</span>
            )}
          </button> */}

          {showNotifications && (
            <div className="dropdown-menu notif-dropdown">
              <div className="dropdown-header">
                <span>Notifications</span>
                <button className="mark-read-btn">
                  <FaCheckCircle /> Mark all read
                </button>
              </div>
              <div className="dropdown-list">
                {notifications.map((n) => (
                  <div className="dropdown-item" key={n.id}>
                    <span className="notif-dot" />
                    <div className="notif-content">
                      <p className="notif-text">{n.text}</p>
                      <span className="notif-time">{n.time}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="dropdown-footer">
                <a href="#">View all notifications</a>
              </div>
            </div>
          )}
        </div>

        {/* PROFILE */}
        <div className="dropdown-wrapper" ref={profileRef}>
          <div
            className="topbar-user"
            onClick={() => {
              setShowProfile((p) => !p);
              setShowNotifications(false);
            }}
          >
            <FaUserCircle className="user-avatar-icon" />
            <span className="user-name">{user?.name || 'User'}</span>
          </div>

          {showProfile && (
            <div className="dropdown-menu profile-dropdown">
              <div className="dropdown-header profile-header">
                <FaUserCircle className="profile-avatar-lg" />
                <div>
                  <p className="profile-name">{user?.name || 'User'}</p>
                  <span className="profile-email">{user?.email || ''}</span>
                </div>
              </div>
              {/* <div className="dropdown-list">
                <div className="dropdown-item">
                  <FaUser className="dropdown-item-icon" />
                  <span>My Profile</span>
                </div>
                <div className="dropdown-item">
                  <FaCog className="dropdown-item-icon" />
                  <span>Settings</span>
                </div>
              </div> */}
              <div className="dropdown-footer">
                 <div className="dropdown-item logout-item" onClick={handleLogout}>
                  <FaSignOutAlt className="dropdown-item-icon" />
                  <span>Logout</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Topbar;